export class TabItem {
  public title: string;
  public visible: boolean;
  public disabledTooltipMessage: string = '';
  public badge: number = 0;
  public showBadge: boolean = false;
  public disabled: boolean = false;

  constructor(init?: Partial<TabItem>) {
    Object.assign(this, init);
  }
}
